import { render } from "./UploadPage.vue?vue&type=template&id=4aab98de&scoped=true"
import script from "./UploadPage.vue?vue&type=script&lang=js"
export * from "./UploadPage.vue?vue&type=script&lang=js"

import "./UploadPage.vue?vue&type=style&index=0&id=4aab98de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aab98de"]])

export default __exports__